import { BookOpen, Layers, TrendingDown } from 'lucide-react';

import { PillarCard } from '../components/PillarCard';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ThreePillarsSection.module.css';

const pillars = [
  {
    body: 'Pre-built courses for adopters, AI-assisted authoring for builders. Faculty keep the copyright. No lock-in. No publisher contract.',
    ctaHref: '/faculty',
    ctaLabel: 'Learn how it works',
    icon: <BookOpen aria-hidden="true" size={24} />,
    title: 'Your content, supercharged.',
  },
  {
    body: 'One platform replaces the publisher, homework system, clicker, AI subscription, and accessibility remediation. One login for faculty. One review for IT.',
    ctaHref: '/institutions',
    ctaLabel: 'See the institutional view',
    icon: <Layers aria-hidden="true" size={24} />,
    title: 'The whole stack, one partner.',
  },
  {
    body: '$25 per student per semester, all-in — including premium AI tutoring most campuses are paying for separately. Inclusive-access programs can finally break even.',
    ctaHref: '/institutions#pricing',
    ctaLabel: 'See the math',
    icon: <TrendingDown aria-hidden="true" size={24} />,
    title: 'Economics that actually work.',
  },
] as const;

export function ThreePillarsSection() {
  return (
    <SectionWrapper background="soft" data-testid="marketing-section-pillars">
      <div className={styles.section}>
        <div className={styles.intro}>
          <h2 className={styles.title}>One platform. Everything your class needs.</h2>
          <p className={styles.subhead}>
            Kudu replaces the stack of tools your faculty juggle today — at a
            price that makes inclusive-access programs actually work.
          </p>
        </div>

        <div className={styles.grid}>
          {pillars.map((pillar) => (
            <PillarCard key={pillar.title} {...pillar} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
